/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiExcelExcelJobOrderForm1Get$Params {
  plantilla_ids?: Array<string>;
}

export function apiExcelExcelJobOrderForm1Get(http: HttpClient, rootUrl: string, params?: ApiExcelExcelJobOrderForm1Get$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, apiExcelExcelJobOrderForm1Get.PATH, 'get');
  if (params) {
    rb.query('plantilla_ids', params.plantilla_ids, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

apiExcelExcelJobOrderForm1Get.PATH = '/api/Excel/Excel_JobOrderForm1';
